// extracted by mini-css-extract-plugin
export default {"v-application":"Datepicker_v-application_no7nb","text-h1":"Datepicker_text-h1_URVpL","text-h2":"Datepicker_text-h2_LfAw6","menu":"Datepicker_menu_qaJEM"};